import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { concatLatestFrom } from '@ngrx/operators';
import { moduleActions } from '@app/store/module/actions/module.actions';
import { modulesActions } from '../actions/modules.actions';
import { selectLastParams } from '../selectors/modules.selector';

@Injectable()
export class ModuleModulesBridge {
    private readonly actions = inject(Actions);
    private readonly store = inject(Store);

    refreshOnMutation$ = createEffect(() => {
        return this.actions.pipe(
            ofType(moduleActions.createModuleSuccess, moduleActions.updateModuleSuccess, moduleActions.deleteModuleSuccess),
            concatLatestFrom(() => this.store.select(selectLastParams)),
            map(([, lastParams]) => modulesActions.getModules({ value: lastParams })),
        );
    });
}
